// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.passwordmanager-column {
    min-width: 150px;
}

.passwordmanager-error {
    margin: 3px 0 0 10px;
    font-size: 12px;
    padding: 5px;
    top: 0;
    max-width: 260px;
}

.passwordmanager input {
    background: transparent;
}`, "",{"version":3,"sources":["webpack://./js/lib/components/passwordmanager/style.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,MAAM;IACN,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":[".passwordmanager-column {\n    min-width: 150px;\n}\n\n.passwordmanager-error {\n    margin: 3px 0 0 10px;\n    font-size: 12px;\n    padding: 5px;\n    top: 0;\n    max-width: 260px;\n}\n\n.passwordmanager input {\n    background: transparent;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
